module.exports = __webpack_public_path__ + "media/images/messagecard-37444b4c3f9251eaf23ab7c30922f949.jpg";